import axios from "axios";
const appleWalletFunctionApiBaseUrl = "https://apple-wallet-m5op6kpyrq-uc.a.run.app/";
const googleWalletFunctionApiBaseUrl = "https://google-wallet-m5op6kpyrq-uc.a.run.app/";
const instance = axios.create({
    baseURL: googleWalletFunctionApiBaseUrl,
    // 5 minutes
    timeout: 300000,
    headers: {
        "Access-Control-Allow-Origin": "*"
    }
});
export async function getGoogleToken(userId, storeId) {
    return instance.get(`api/GoogleWallet/${storeId}/${userId}`);
}

export function getAppleAPIUrl(userId, storeId) {
    return appleWalletFunctionApiBaseUrl + `api/AppleWallet/${storeId}/${userId}`;
}
